import { MarketplaceProvider } from './interfaces';
import { Marketplace } from './marketplace';

/**
 * EmptyMarketplace with undefined marketplaceId, locale, and currencyCode
 */
class EmptyMarketplace extends Marketplace {}

/**
 * This class providing a provider generate EmptyMarketplace,
 * as default marketplace provider in marketplace-creator
 */
// tslint:disable-next-line:max-classes-per-file
export class EmptyMarketplaceProvider implements MarketplaceProvider {
    private static readonly emptyMarketplace: Marketplace = new EmptyMarketplace();

    public getMarketplace(): Marketplace {
        return EmptyMarketplaceProvider.emptyMarketplace;
    }
}
